import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useTimeout } from "../../common/hooks";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const ARIA_CAPTION_CLEAR_DURATION = 1000;
/**
 * Table utility Component to announce changes in a sortable Pioneer WFRIA table.
 */

export function TableARIAChangeAnnouncer(props) {
  const ariaDeclarationContainerRef = useRef(null);
  useTimeout(() => {
    ariaDeclarationContainerRef.current && (ariaDeclarationContainerRef.current.innerText = "");
  }, ARIA_CAPTION_CLEAR_DURATION, true);
  return _jsx("span", {
    className: "wf-u-visually-hidden",
    "aria-live": "assertive",
    ref: ariaDeclarationContainerRef,
    children: props.liveText
  });
}
TableARIAChangeAnnouncer.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/require-default-props
  liveText: PropTypes.string
} : {};
/**
 * Utility function to derive an aria-live ready caption for table.
 * @param {String} caption A string representing a caption.
 * @param {String | Node} ariaCaption A string or node representing a visually hidden caption.
 * @returns {Node} A caption node with aria-caption updated on every sort change.
 */

function renderAriaLiveCaption(caption, ariaCaption, className) {
  const captionClassNames = clsx({
    [className]: caption
  });
  return _jsxs("caption", {
    className: captionClassNames,
    children: [caption, ariaCaption && _jsxs("span", {
      className: "wf-u-visually-hidden",
      children: [`${caption ? ", " : ""}`, ariaCaption]
    })]
  });
}
/**
 * Table utility component to render caption section of a Pioneer WFRIA table.
 */


export default function TableCaption(props) {
  const {
    caption,
    ariaCaption,
    className
  } = props;
  return renderAriaLiveCaption(caption, ariaCaption, className);
}